import type { ReactNode } from 'react';

import { Notice } from '@/components/Notice';
import { errorText } from '@/errorText';
import { useT } from '@/str';

export function ErrorNotice({
  error,
  onRetry,
  children,
}: {
  error: unknown;
  onRetry?: () => void;
  children?: ReactNode;
}) {
  const t = useT();
  return (
    <Notice sign="!" title={t.errTitle} body={errorText(error, t)} onRetry={onRetry}>
      {children}
    </Notice>
  );
}
